import * as React from 'react';
import styled, { css } from 'styled-components';
import check from 'assets/check.svg';
import error from 'assets/x.svg';
import { DataCy } from '../../../types/dataAttributes';
import { InputState } from './Deprecated/JRCFormFieldRender';

/**
 * Input styles are &&& encapsulated in order to go over the reset styles
 * and the not-resseted legacy style set with input[type="toto"]
 */

export type IconsProps = {
    hasIconBefore?: boolean;
    hasIconAfter?: boolean;
};

export const cssCommonStyledInput = css<InputState & IconsProps>`
    &&&& {
        font-size: 16px;
        color: ${(props) => props.theme.color.grey5};
        border: 1px solid ${(props) => props.theme.color.grey2};
        width: 100%;
        height: 40px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 8px 16px;
        ${(props) => props.hasIconBefore && 'padding-left: 40px;'};
        ${(props) => props.hasIconAfter && 'padding-right: 40px;'};

        margin-bottom: 4px;
        box-shadow: none;
        transition: border 0.2s, box-shadow 0.2s;

        &:hover:not(:disabled):not(:read-only) {
            box-shadow: 0 0 2px ${(props) => props.theme.color.grey2};
        }

        &:focus:not(:read-only) {
            border-color: ${(props) => props.theme.color.navy};
            box-shadow: 0 0 2px ${(props) => props.theme.color.grey4};
        }

        &:placeholder-shown {
            text-overflow: ellipsis;
        }

        ${(props) =>
            props.valid &&
            `
            border-color: ${props.theme.color.green};
            background-image: url(${check});
            background-repeat: no-repeat;
            background-position: calc(100% - 14px) 14px;
            background-size: 12px;
            &:focus {
                border-color: ${props.theme.color.green};
                box-shadow: none;
            }
        `}

        ${(props) =>
            props.error &&
            `
            border-color: ${props.theme.color.orange};
            background-image: url(${error});
            background-repeat: no-repeat;
            background-position: calc(100% - 14px) 14px;
            background-size: 12px;
        `}
    }

    ${(props) =>
        props.readOnly &&
        ` &&&& {
            background-color: white;
            cursor: default;
            border-color: ${props.theme.color.grey1};
        }`};
`;

export const cssStyledInput = css<InputState>`
    ${cssCommonStyledInput}
    &&&::placeholder {
        color: ${(props) => props.theme.color.grey3};
        font-size: 16px;
        font-style: normal;
        opacity: 1;
    }
`;

export const StyledInput = styled.input.attrs<InputState>(({ dataCy, ...props }) => ({ 'data-cy': dataCy, ...props }))`
    ${cssStyledInput}
    &&& {
        &.inputFile {
            visibility: hidden;
            display: none;
        }
    }
`;

export type StyledSelectProps = DataCy &
    IconsProps & {
        searchable?: boolean;
        sizeVariant?: 's' | 'md';
    };

export const StyledSelect = styled(StyledInput)<StyledSelectProps>`
    ${(props) => !props.searchable && 'caret-color: transparent'};
    ${(props) => !props.searchable && 'cursor: pointer'};

    ${({ sizeVariant }) =>
        sizeVariant === 's' &&
        `
        &&&& {
            font-size: 12px;
            padding: 4px 40px 4px 8px;
            height: initial;
            border-radius: 6px;
        }
    `}
`;

export const MaxLengthIndicatorContainer = styled.div`
    text-align: right;
    margin-top: -24px;
`;

export const MaxLengthIndicator = ({ maxLength, actualLength }: { maxLength?: number; actualLength: number }) => (
    <>
        {maxLength && (
            <MaxLengthIndicatorContainer>
                {actualLength}/{maxLength}
            </MaxLengthIndicatorContainer>
        )}
    </>
);
